import {
  Block,
  BlockProps,
  LabelMedium,
  Mats,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  DISABLE_TESTNET_MATS_REWARDS,
  SIGN_UP_MATS_REWARD,
} from "#/shared/constants"

export default function OnboardingModalReward({
  children,
  ...props
}: BlockProps) {
  const [css, theme] = useStyletron()

  if (DISABLE_TESTNET_MATS_REWARDS) return null

  return (
    <Block
      className={css({
        width: "100%",
        marginTop: theme.sizing.scale300,
        padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
        borderWidth: theme.borders.border100.borderWidth,
        borderRadius: theme.borders.radius400,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      })}
      {...props}
    >
      <ParagraphMedium>{children}</ParagraphMedium>
      <Block
        className={css({
          display: "flex",
          alignItems: "center",
          gap: theme.sizing.scale700,
        })}
      >
        <LabelMedium>{SIGN_UP_MATS_REWARD}</LabelMedium>
        <Mats />
      </Block>
    </Block>
  )
}
